/* ACP V9 — slide-in cart with cross-sell. Talks to Shopify's Ajax Cart API only. */
(function () {
  var A = window.ACP || {};
  var S = A.strings || {};
  var R = A.routes || {};
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.acp9-drawer__panel');
  var itemsEl = drawer.querySelector('[data-drawer-items]');
  var recsEl = drawer.querySelector('[data-drawer-recs]');
  var footEl = drawer.querySelector('[data-drawer-foot]');
  var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
  var countEl = drawer.querySelector('[data-drawer-count]');
  var assureEl = drawer.querySelector('[data-drawer-assure]');
  var deliveryEl = drawer.querySelector('[data-drawer-delivery]');
  var offerEl = drawer.querySelector('[data-drawer-offer]');
  var lastFocus = null;
  var recsFor = null;
  var busy = false;

  function money(c) { return window.ACPU ? ACPU.formatMoney(c) : String(c / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(url, w) {
    if (!url) return '';
    try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); }
    catch (e) { return url; }
  }

  function getCart() {
    return fetch(R.cartJs || '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function render(cart) {
    updateCount(cart);
    var n = cart.item_count;
    countEl.textContent = n ? '(' + n + ')' : '';

    if (!n) {
      itemsEl.innerHTML =
        '<div class="acp9-drawer__empty"><p>' + esc(S.empty) + '</p>' +
        '<a class="acp9-btn acp9-btn--primary" href="' + esc((R.cart || '/cart').replace(/cart$/, '') + '#shop') + '">' + esc(S.emptyCta) + '</a></div>';
      footEl.hidden = true; assureEl.hidden = true; recsEl.hidden = true;
      if (offerEl) offerEl.hidden = true;
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="acp9-line__variant">' + esc(it.variant_title) + '</p>' : '';
      return '' +
        '<article class="acp9-line" data-line="' + esc(it.key) + '">' +
          '<a class="acp9-line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
          '<div class="acp9-line__main">' +
            '<a class="acp9-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
            '<div class="acp9-line__row">' +
              '<div class="acp9-qty" role="group">' +
                '<button type="button" data-qty="-1" aria-label="' + esc(S.qtyMinus) + '">−</button>' +
                '<span aria-live="polite">' + it.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="' + esc(S.qtyPlus) + '">+</button>' +
              '</div>' +
              '<strong class="acp9-line__price">' + esc(money(it.final_line_price)) + '</strong>' +
            '</div>' +
            '<button type="button" class="acp9-line__remove" data-remove>' + esc(S.remove) + '</button>' +
          '</div>' +
        '</article>';
    }).join('');

    subtotalEl.textContent = money(cart.total_price);
    footEl.hidden = false;
    assureEl.hidden = false;
    if (offerEl) offerEl.hidden = false;
    if (window.ACPU && deliveryEl) {
      var d = ACPU.deliveryRange();
      deliveryEl.textContent = (S.delivery || '%RANGE%').replace('%RANGE%', d.fromShort + ' – ' + d.toShort);
    }
    loadRecs(cart);
  }

  function loadRecs(cart) {
    var last = cart.items[0];
    if (!last || !last.product_id || !R.recs) { recsEl.hidden = true; return; }
    if (recsFor === last.product_id && recsEl.innerHTML) { recsEl.hidden = false; return; }
    recsFor = last.product_id;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    fetch(R.recs + '.json?product_id=' + last.product_id + '&limit=6&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var list = (data.products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 2);
        if (!list.length) { recsEl.hidden = true; return; }
        recsEl.innerHTML = '<h3>' + esc(S.recsTitle) + '</h3><div class="acp9-recs-mini">' + list.map(function (p) {
          var price = (S.from || '%PRICE%').replace('%PRICE%', money(p.price_min != null ? p.price_min : p.price));
          var src = p.featured_image && (p.featured_image.url || p.featured_image);
          return '<a class="acp9-mini" href="' + esc(p.url) + '">' +
            (src ? '<img src="' + esc(img(src, 320)) + '" alt="" width="160" height="106" loading="lazy">' : '') +
            '<span>' + esc(p.title) + '</span><small>' + esc(price) + '</small></a>';
        }).join('') + '</div>';
        recsEl.hidden = false;
      })
      .catch(function () { recsEl.hidden = true; });
  }

  function change(key, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    drawer.classList.add('is-busy');
    return fetch(R.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(render)
      .catch(function () { itemsEl.insertAdjacentHTML('afterbegin', '<p class="acp9-drawer__error" role="alert">' + esc(S.error) + '</p>'); })
      .then(function () { busy = false; drawer.classList.remove('is-busy'); });
  }

  function open() {
    if (!drawer.hidden && drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('acp9-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); panel.focus({ preventScroll: true }); }); });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('acp9-lock');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function refresh(opts) {
    return getCart().then(function (cart) { render(cart); if (opts && opts.open) open(); return cart; });
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    var line = e.target.closest('[data-line]');
    if (!line) return;
    var key = line.getAttribute('data-line');
    var q = e.target.closest('[data-qty]');
    if (q) {
      var cur = parseInt(line.querySelector('.acp9-qty span').textContent, 10) || 1;
      change(key, Math.max(0, cur + parseInt(q.getAttribute('data-qty'), 10)));
    } else if (e.target.closest('[data-remove]')) {
      change(key, 0);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

  // Header cart link opens the drawer; middle-click / cmd-click still open the cart page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    refresh({ open: true });
  });

  window.ACPCart = { open: open, close: close, refresh: refresh, render: render };
})();
